import { Card, CardProps, Typography } from "antd";

export interface ProductItemCardTemplateProps extends CardProps {
  orderItemNo?: string;
}

/**
 * 상품상세 카드폼
 * @param param0
 * @returns
 */
export const ProductItemCardTemplate: React.FC<
  ProductItemCardTemplateProps
> = ({ orderItemNo, ...props }) => {
  return (
    <Card
      title={
        <Typography.Text style={{ fontWeight: 700 }}>
          상품 주문번호 : {orderItemNo || "-"}
        </Typography.Text>
      }
      bordered={false}
      bodyStyle={{
        width: "100%",
        marginTop: 1,
        padding: 20,
      }}
      {...props}
    />
  );
};
